<template>
<zj-layout-container>
  <zj-layout-header>
    <div class="listtitle">巡检异常列表</div>
    <el-form
      class="zj-search-form"
      ref="form"
      :model="form"
      :label-width="labelWidth">
      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker
          v-model="startTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择开始时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-date-picker
          v-model="endTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择结束时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="计划名称" prop="planname">
        <el-input v-model="listQuery.planname" placeholder="请输入计划名称"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="listQuery.status" placeholder="请选择">
          <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="巡检人员" prop="user">
        <el-input v-model="listQuery.staffName" placeholder="请输入巡检人员"></el-input>
      </el-form-item> -->
      
      <el-form-item label="" class="right">
        <el-button @click="onSearch">查 询</el-button>
        <el-button @click="onCancel">清 理</el-button>
      </el-form-item>
    </el-form>
    <el-divider></el-divider>
  </zj-layout-header>
  <zj-layout-main>
    <div class="zj-layout-main-content bgcolor scrollable">
      <div class="zj-table-container">
        <el-table
          :data="tableData"
          border
          ref="multipleTable"
          style="width: 100%"
          fixed>
          <el-table-column type="index" label="序号" width="80" :index="index"  align="center">
          </el-table-column>
          <el-table-column prop="name" label="计划名称">
          </el-table-column>
          <el-table-column prop="staffName" label="巡检人员" align="center">
          </el-table-column>
          <el-table-column prop="startdate" label="开始时间" align="center">
          </el-table-column>
          <el-table-column prop="singlePatroltime" label="执行时间" align="center">
          </el-table-column>  
          <el-table-column prop="statusName" label="异常类型" align="center">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </zj-layout-main>
  <zj-layout-footer>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    ></el-pagination>
  </zj-layout-footer>
</zj-layout-container>
</template>

<script>
import { getPatrolAbnormalList, getPatrolTaskList } from '@/request/patrolApi';
export default {
  name: 'ZjPatrolAbnormal',
  controller: 'UI',
  action: 'Abnormal',
  data() {
    return {
      startTime: new Date().format("yyyy-MM-dd"),
      endTime: new Date().format("yyyy-MM-dd"),
      listQuery: {
        taskSource: 1,
        staffName: '',
        planname: '',
        status: '6',
        startdates: ''
      },

      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      statusList: [{
        value:"6",
        label:'全部'
      },{
        value:'5',
        label:'过期未执行'
      },{
        value:'8',
        label:'过期未完成'
      },{
        value:'9',
        label:'超时完成'
      }]
    };
  },
  created: function() {
    if (this.$route.query.jump) {
      this.startTime = '';
      this.endTime = '';
    }
    this.search()
  },
  mounted: function() {
    
  },
  filters: {
    formatDatSingle(data) {
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    
    search() {
      if (this.startTime) {
        if (!this.endTime) {
          this.$message({
            type: "warning",
            message: "请选择结束时间",
          });
          return;
        }
      } else {
        if (this.endTime) {
          this.$message({
            type: "warning",
            message: "请选择开始时间",
          });
          return;
        }
      }
      this.listQuery.startdates = this.startTime + ',' + this.endTime
      let searchInfo = {
        ...this.listQuery,
        page: this.currentPage,
        size: this.pageSize,
        culturaCompanyCode: this.user.userInfo.organization[0].code,
      };
      getPatrolTaskList(searchInfo).then((r) => {
        if (r.code === 0 && r.data) {
          this.tableData = r.data;
          this.total = r.count || 0;
        }
      }).catch((e) => {
        console.log(e);
        this.errmsg(e.msg ? e.msg : "服务异常，请联系管理员！");
      });
    },
    clearsearch() {
      this.startTime = '';
      this.endTime = '';
      this.listQuery.planname = '';
      this.listQuery.status = '';
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    }
  }
}
</script>
